import { getApiUrl, getCurrentLanguageId, getQueryString, QueryParameter } from './common';
import HttpClient from './http-client';
import LoadingIndication from './loading-indication';
import ConfirmDialog from './confirm-dialog';


export default class SharedCart {
    private addToCartButton: HTMLInputElement;

    initForSharedCart(addToCartButtonId: string): void {
        this.initAddToCartElements(addToCartButtonId);
        this.registerAddToCartListeners();
    }

    private initAddToCartElements(addToCartButtonId: string): void {
        this.addToCartButton = <HTMLInputElement>document.getElementById(addToCartButtonId);
    }

    private registerAddToCartListeners(): void {
        this.addToCartButton.addEventListener('click', async () => {

            const confirmDialog = new ConfirmDialog(async () => {
                await this.addItemsToCart();
            });

            const queryParam: QueryParameter = {
                key: 'confirmDialogViewName',
                value: 'ConfirmAddItemsToCart'
            };

            confirmDialog.open([queryParam]);
        });
    }

    private getApiUrl(): string {
        return `${getApiUrl()}/sharedcart`;
    }

    public getBaseElement(): HTMLElement {
        return document.querySelector('[data-component="SharedCart"]');
    }

    private async addItemsToCart(): Promise<void> {
        LoadingIndication.show(this.getBaseElement());

        const url = `${this.getApiUrl()}/addtocart${this.addQueryParams()}`;
        const languageId = getCurrentLanguageId();
        const response = await new HttpClient().fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Current-Language-Id': languageId
            },
        });

        if (response && response.ok) {
            await this.onSuccess(response);
        } else {
            LoadingIndication.hide(this.getBaseElement());
        }
    }

    private async onSuccess(response: Response): Promise<void> {
        this.redirectToPage(await response.text());
    }

    private addQueryParams(): string {
        return `?${getQueryString()}`;
    }

    private redirectToPage(pageUrl: string): void {
        window.location.href = pageUrl;        
    }
}
